import React, { useEffect } from 'react';
import './ligas_interes.css';
import { ligas_lnteres } from '../../json/ligas_interes';

const Ligas_Interes = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Ligas de Interes</h3>
                <hr className='hr-gob'/>
            </div>
        </div>
        <div className='row'>
            {
                ligas_lnteres.map((item, index)=>(
                    <div key={ index } className='col-md-12 col-sm-6 col-12'>
                        <div className='card_container_ligas'>
                            <div className='card_anio'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.ligas.map((trim, index)=>(
                                        <h4>
                                            <div key={ index } className='card_liga'>
                                                <p>{ trim.liga } <span className="badge bg-secondary">
                                                    <a href={ trim.url } target="_blank">Ver</a></span>
                                                </p> 
                                            </div>
                                        </h4>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
                <div>
                
                <hr className='hr-gob'/>
            </div>
        </div>
    </div>
  )
}

export default Ligas_Interes